module.exports = __webpack_public_path__ + "static/media/reverb-posters.fbc7b2f1.png";